import { render, staticRenderFns } from "./trial_mould_wo_attachment_dialog.vue?vue&type=template&id=067df7fb&scoped=true&"
import script from "./trial_mould_wo_attachment_dialog.vue?vue&type=script&lang=js&"
export * from "./trial_mould_wo_attachment_dialog.vue?vue&type=script&lang=js&"
import style0 from "./trial_mould_wo_attachment_dialog.vue?vue&type=style&index=0&id=067df7fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067df7fb",
  null
  
)

export default component.exports